import { RENDER_TYPE_NOT_SUPPORTED, factoryRenderers } from './factoryRenderers';

export const getRender = (renderType) => factoryRenderers().find((render) => render.type === renderType);

export const getAvailableRenderers = (instances) => {
  const availableRenderers = [];

  const isSupportedInstances = instances.filter((instance) => factoryRenderers().some((renderer) => renderer.isSupported([instance])));

  factoryRenderers().forEach((item) => {
    const tilted = item.isTilted && item.isTilted(isSupportedInstances);
    if (item.isSupported(isSupportedInstances) && !tilted) {
      availableRenderers.push(item.type);
    }
  });

  if (availableRenderers.length === 0) {
    availableRenderers.push(RENDER_TYPE_NOT_SUPPORTED);
  }

  return availableRenderers;
};

export const isRenderableSeries = (series) => {
  const availableRenderers = getAvailableRenderers(series.instances);
  if (availableRenderers.length > 0) {
    return true;
  } else {
    console.log('serie without any renderable instance, check SOPClassUID');
    return false;
  }
};

export default getAvailableRenderers;
